import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorsComponent } from './components/errors/errors.component';
import { PrimeModule } from './primeng/primeng-module';
import { ModalImagePickerComponent } from './modals/modal-image-picker/modal-image-picker.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ImagePipe } from './pipes/image.pipe';
import { DisplayRolePipe } from './pipes/show-role.pipe';
import { ModalNewCompanionComponent } from './modals/modal-new-companion/modal-new-companion.component';
import { TravelErrorsComponent } from './components/travel-errors/travel-errors.component';
import { TravelTypePipe } from './pipes/travel-type.pipe';
import { ModalNewAirportComponent } from './modals/modal-new-airport/modal-new-airport.component';
import { ModalNewFlightCompanyComponent } from './modals/modal-new-flight-company/modal-new-flight-company.component';
import { ModalFilePickerComponent } from './modals/modal-file-picker/modal-file-picker.component';
import { BytesPipe } from './pipes/bytes.pipe';
import { CurrencyPipe } from './pipes/currency.pipe';
import { PaymentMethodPipe } from './pipes/payment-method.pipe';
import { BookingStatusPipe } from './pipes/booking-status.pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { BookingStatusLabelPipe } from './pipes/booking-status-label.pipe';
import { ModalTravelManagementComponent } from './modals/modal-travel-management/modal-travel-management.component';
import { PaymentStatusLabelPipe } from './pipes/status-label.pipe';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { CloudImagePickerComponent } from './modals/cloud-image-picker/cloud-image-picker.component';
import { DaysAndNightsPipe } from './pipes/days-nights.pipe';

@NgModule({
  declarations: [
    ErrorsComponent,
    TravelErrorsComponent,
    ModalImagePickerComponent,
    ModalNewCompanionComponent,
    ImagePipe,
    DisplayRolePipe,
    TravelTypePipe,
    SlugifyPipe,
    ModalNewAirportComponent,
    ModalNewFlightCompanyComponent,
    ModalFilePickerComponent,
    CloudImagePickerComponent,
    BytesPipe,
    CurrencyPipe,
    PaymentMethodPipe,
    BookingStatusPipe,
    PaymentStatusPipe,
    BookingStatusLabelPipe,
    PaymentStatusLabelPipe,
    ModalTravelManagementComponent,
    DaysAndNightsPipe
  ],
  exports: [
    ErrorsComponent,
    TravelErrorsComponent,
    ModalImagePickerComponent,
    ModalNewCompanionComponent,
    ImagePipe,
    DisplayRolePipe,
    TravelTypePipe,
    SlugifyPipe,
    ModalFilePickerComponent,
    BytesPipe,
    CurrencyPipe,
    PaymentMethodPipe,
    BookingStatusPipe,
    PaymentStatusPipe,
    BookingStatusLabelPipe,
    DaysAndNightsPipe
  ],
  imports: [
    CommonModule, 
    PrimeModule, 
    ReactiveFormsModule, 
    ImageCropperComponent
  ],
  providers: [SlugifyPipe]
})
export class SharedModule {}